import api from './api';

export type FeedbackSource = 'button' | 'ace-check' | 'tour-check';

export interface FeedbackEntry {
  id: string;
  at: string; // ISO timestamp
  by: { username: string; name: string; role: string };
  source: FeedbackSource;
  kind: string | null;   // chip or answer the person picked, if any
  reasons: string[];     // optional "what was off" chips (quick checks only)
  note: string;
  page: { label: string; path: string };
  about: string | null;  // what it's about: a picked element, an Ace task, a tour
}

export interface NewFeedback {
  source: FeedbackSource;
  kind: string | null;
  reasons?: string[];
  note: string;
  page: string;
  about: string | null;
}

export async function createFeedback(input: NewFeedback): Promise<FeedbackEntry> {
  const payload = {
    source: input.source,
    kind: input.kind,
    reasons: input.reasons ?? [],
    note: input.note,
    page_label: input.page,
    page_path: window.location.pathname + window.location.search,
    about: input.about,
  };
  const r = await api.post<FeedbackEntry>('/api/v1/feedback', payload);
  return r.data;
}

export async function listMyFeedback(): Promise<FeedbackEntry[]> {
  const r = await api.get<FeedbackEntry[]>('/api/v1/feedback/mine');
  return r.data;
}

// Admin/dev-team view — requires the feedback.manage capability.
export async function listAllFeedback(): Promise<FeedbackEntry[]> {
  const r = await api.get<FeedbackEntry[]>('/api/v1/feedback');
  return r.data;
}
